module.exports = __webpack_public_path__ + "img/5.af7916d9.png";